import * as z from "zod";

export const getReturnsVelocityBenchmarksInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
});
export type GetReturnsVelocityBenchmarksInput = z.infer<
  typeof getReturnsVelocityBenchmarksInputSchema
>;

const benchmarkSchema = z.object({
  medianDays: z.number().min(0).nullable(),
  p90Days: z.number().min(0).nullable(),
  sampleSize: z.number().int().min(0),
});
export type ReturnsVelocityBenchmark = z.infer<typeof benchmarkSchema>;

export const getReturnsVelocityBenchmarksOutputSchema = z.object({
  /** Linked HubSpot deal created -> monetization enabled. */
  dealCreatedToMonetizationEnabled: benchmarkSchema,
  /** Onboarding completed -> monetization enabled. */
  completedToMonetizationEnabled: benchmarkSchema,
});
export type GetReturnsVelocityBenchmarksOutput = z.infer<
  typeof getReturnsVelocityBenchmarksOutputSchema
>;

export const getReturnsVelocityBenchmarks = {
  name: "getReturnsVelocityBenchmarks" as const,
  input: getReturnsVelocityBenchmarksInputSchema,
  output: getReturnsVelocityBenchmarksOutputSchema,
};
